import { render, staticRenderFns } from "./video.vue?vue&type=template&id=b7f07160&scoped=true"
import script from "./video.vue?vue&type=script&setup=true&lang=js"
export * from "./video.vue?vue&type=script&setup=true&lang=js"
import style0 from "./video.vue?vue&type=style&index=0&id=b7f07160&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f07160",
  null
  
)

export default component.exports